/**
 * Whitby Abrasives — language / country selector fix
 *
 * Symptom: clicking Français or Español in the header or footer has no
 * effect — the page stays in English.
 *
 * Root cause: The Warehouse theme's popover and value-picker JS calls
 * form.submit() programmatically to switch the locale.  That method does
 * NOT include the clicked <button name="locale_code" value="fr"> in the
 * POST body — only hidden inputs travel with form.submit().  The form
 * always has a hidden <input name="locale_code" value="en"> (the current
 * locale), so every click silently re-submits English.
 *
 * Fix: register a capture-phase click listener on the document.  Capture
 * runs before any bubbling-phase handler the theme may have.  When a
 * locale or country submit button is clicked we:
 *   1. Stop all other handlers (stopImmediatePropagation in capture phase).
 *   2. Sync the matching hidden input to the button's value.
 *   3. Submit the form natively — now locale_code = "fr" / "es" travels.
 *
 * Covers: header popover, footer value-picker, and any future selectors
 * that use button[name="locale_code"] or button[name="country_code"].
 *
 * Deployed as a Shopify Script Tag so it loads on every storefront page
 * without touching live theme files.  Remove via the Script Tags API when
 * this fix is merged into the theme's custom.js.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    // Find a locale or country submit button at or above the click target
    var btn = e.target.closest(
      'button[type="submit"][name="locale_code"],' +
      'button[type="submit"][name="country_code"]'
    );
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;

    // Block theme handlers so they cannot call form.submit() before us
    e.stopImmediatePropagation();
    e.preventDefault();

    // Sync the hidden input to the value the user clicked
    var fieldName  = btn.name;
    var fieldValue = btn.value;

    var hidden = form.querySelector('input[type="hidden"][name="' + fieldName + '"]');
    if (hidden) {
      hidden.value = fieldValue;
    } else {
      var inp = document.createElement('input');
      inp.type  = 'hidden';
      inp.name  = fieldName;
      inp.value = fieldValue;
      form.appendChild(inp);
    }

    // Native form.submit() — no submit event fires, so no double-handler risk.
    // All hidden inputs (locale_code, country_code, return_to, etc.) travel intact.
    form.submit();

  }, true); // true = capture phase — guaranteed to run before theme bubbling handlers

})();
